import React, { useState } from "react";

import styled from "styled-components";

import FormInput from "components/atoms/input/FormInput";
import useLoading from "components/atoms/loading/useLoading";
import Text from "components/atoms/text/Text";

import AbstractModalFooter from "components/page/modal/AbstractModalFooter";

import { genericEnterKeyDown } from "utils/validation";

const Container = styled.div`
    width: 100%;
`;

function ReferenceAddDoiModal(props) {
    const [doi, setDoi] = useState("");
    const { setLoading } = useLoading();

    const handleAddButton = () => {
        setLoading(true, "참고문헌 정보를 확인 중입니다.");
        props.mutation.mutate(
            {
                addFromSource: true,
                body: {
                    source: "doi",
                    source_id: doi,
                },
            },
            {
                onSettled: () => {
                    setLoading(false);
                },
            },
        );
    };

    return (
        <Container>
            <Text variant="body-md">참고문헌 추가를 위해 DOI를 입력해주세요.</Text>
            {/* DOI로 참고문헌 추가 기능 */}
            <FormInput
                width="100%"
                margin="24px 0 0 0"
                label="DOI"
                bgColor="var(--color-Base1)"
                borderless
                requiredMark
                rightInfoText="DOI"
                tooltipMessage="DOI(Digital Object Identifier)는 디지털 콘텐츠를 고유하게 식별하는 데 사용되는 표준 정보 식별자입니다."
                placeholder="EX) 10.1038/nature16961"
                onChange={(e) => setDoi(e.target.value)}
                onKeyDown={(e) => {
                    genericEnterKeyDown(e, () => {
                        handleAddButton();
                    });
                }}
                value={doi}
            />
            <AbstractModalFooter
                leftBtnText={"취소"}
                rightBtnText={"추가"}
                leftOnClick={props.exitModal}
                rightOnClick={handleAddButton}
                disabled={!doi}
            />
        </Container>
    );
}

export default ReferenceAddDoiModal;
